module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/187-vanuatu-53b29e29b83503d39ccb559131c8dc7e.svg";